var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEstatusOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6,
    fill: "#18BA81"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.01899 8.6168L6.01899 7.6168C5.8301 7.42791 5.59677 7.33346 5.31899 7.33346C5.04121 7.33346 4.80788 7.42791 4.61899 7.6168C4.4301 7.80569 4.33843 8.03902 4.34399 8.3168C4.34954 8.59457 4.44677 8.82791 4.63565 9.0168L6.26899 10.6501C6.48414 10.8612 6.73515 10.9668 7.02202 10.9668C7.30889 10.9668 7.55788 10.8612 7.76899 10.6501L11.2857 7.13346C11.4745 6.94457 11.569 6.71402 11.569 6.4418C11.569 6.16957 11.4745 5.93902 11.2857 5.75013C11.0968 5.56124 10.8634 5.4668 10.5857 5.4668C10.3079 5.4668 10.0745 5.56124 9.88565 5.75013L7.01899 8.6168Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEstatusOk);
export default __webpack_public_path__ + "static/media/IconEstatusOk.6f806d005e4f67f04d80e466dde6a5ea.svg";
export { ForwardRef as ReactComponent };